import { UserContact } from 'services/ApiService/ServiceBoard/ServiceBoardApiClient';

export const AuthenticatedUserContactsFetchRequestActionType =
    '@AUTHENTICATED_USER_CONTACTS/FETCH_REQUEST';
export const AuthenticatedUserContactsFetchSuccessActionType =
    '@AUTHENTICATED_USER_CONTACTS/FETCH_SUCCESS';
export const AuthenticatedUserContactsFetchFailureActionType =
    '@AUTHENTICATED_USER_CONTACTS/FETCH_FAILURE';

export type AuthenticatedUserContactsFetchRequestAction = ReduxAction<
    typeof AuthenticatedUserContactsFetchRequestActionType
>;
export type AuthenticatedUserContactsFetchSuccessAction = ReduxAction<
    typeof AuthenticatedUserContactsFetchSuccessActionType,
    { payload: Nullable<UserContact[]> }
>;
export type AuthenticatedUserContactsFetchFailureAction = ReduxAction<
    typeof AuthenticatedUserContactsFetchFailureActionType
>;

export const createAuthenticatedUserContactsFetchRequestAction = (): AuthenticatedUserContactsFetchRequestAction => ({
    type: AuthenticatedUserContactsFetchRequestActionType,
});

export function createAuthenticatedUserContactsFetchSuccessAction(
    user: Nullable<UserContact[]>,
): AuthenticatedUserContactsFetchSuccessAction {
    return {
        type: AuthenticatedUserContactsFetchSuccessActionType,
        payload: user,
    };
}

export const createAuthenticatedUserContactsFetchFailureAction = (): AuthenticatedUserContactsFetchFailureAction => ({
    type: AuthenticatedUserContactsFetchFailureActionType,
});

export type AuthenticatedUserContactsAction =
    | AuthenticatedUserContactsFetchRequestAction
    | AuthenticatedUserContactsFetchSuccessAction
    | AuthenticatedUserContactsFetchFailureAction;